import React, { useState, useEffect } from 'react';
import Logo from '../../assets/images/2025.webp';
import { verifyOtp } from '../../Api';
import './Login.css';

function Daftar() {
  const [email, setEmail] = useState('');
  const [nama, setNama] = useState('');
  const [hp, setHp] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showVerification, setShowVerification] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const [timeLeft, setTimeLeft] = useState(300); // 5 minutes = 300 seconds
  const [verifLoading, setVerifLoading] = useState(false);
  const [verifError, setVerifError] = useState(null);
  const [verifSuccess, setVerifSuccess] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      // const data = await daftarPost(nama, hp, email, password);
      setShowVerification(true);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.errors) {
        const errorObj = err.response.data.errors;
        const allErrors = Object.values(errorObj).flat(); // combine all messages
        setError(allErrors); // store as array
      } else {
        setError(['Terjadi Kesalahan.']);
      }
    } finally {
      setLoading(false);
    }
  };
  const handleVerify = async (e) => {
    e.preventDefault();
    setVerifLoading(true);
    setVerifError(null);

    try {
      const response = await verifyOtp(email, verificationCode);

      // Save to localStorage
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('user', JSON.stringify(response.user));
      setVerifSuccess(true);
      // Redirect to home
      setTimeout(() => {
        window.location.href = '/';
      }, 5000);
    } catch (err) {
      setVerifError('Kode verifikasi salah atau sudah kedaluwarsa.');
    } finally {
      setVerifLoading(false);
    }
  };
  useEffect(() => {
    let timer;
    if (showVerification && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [showVerification, timeLeft]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  return (
    <div className="login-page">
      <img src={Logo} alt="Filadelfia Blessing Family" className="logo" />
      {verifSuccess && (
        <p style={{ color: 'green', textAlign: 'center' }}>
          Kode valid. Saat ini diarahkan ke halaman utama, mohon tunggu...
        </p>
      )}
      {!showVerification && (
        <div>
          <p style={{ fontSize: '12px' }}>
            Pendaftaran saat ini terbuka bagi semua ketua rukun, pasangan, dan
            kader yang akan mengikuti acara Leaders Night pada Senin, 14 Feb
            2025
          </p>
          <h1>Daftar</h1>
          {error && Array.isArray(error) && (
            <ul className="error">
              {error.map((errMsg, index) => (
                <li key={index}>{errMsg}</li>
              ))}
            </ul>
          )}
          <form className="login-form" onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Nama Lengkap"
              value={nama}
              onChange={(e) => setNama(e.target.value)}
              required
            />
            <input
              type="text"
              placeholder="Nomor HP"
              value={hp}
              onChange={(e) => setHp(e.target.value)}
              required
            />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <div className="password-container">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span
                className="password-toggle-icon"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="#6E6BF0"
                    width="20"
                    height="20"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="#6E6BF0"
                    width="20"
                    height="20"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                )}
              </span>
            </div>
            <button type="submit" disabled={loading}>
              {loading ? 'Proses data...' : 'Submit'}
            </button>
          </form>
        </div>
      )}
      {showVerification && !verifSuccess && (
        <div className="verification-section">
          <h2>Verifikasi Kode</h2>
          <p>Silakan masukkan kode yang dikirim ke email Anda.</p>
          <p style={{ fontWeight: 'bold' }}>
            Waktu tersisa: {formatTime(timeLeft)}
          </p>
          <form className="login-form" onSubmit={handleVerify}>
            <input
              type="text"
              placeholder="Kode Verifikasi"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
            />
            <input type="hidden" name="email" value={email} />
            {verifError && (
              <p className="error" style={{ textAlign: 'center' }}>
                {verifError}
              </p>
            )}
            <button type="submit" disabled={verifLoading}>
              {verifLoading ? 'Memverifikasi...' : 'Submit'}
            </button>
          </form>
        </div>
      )}
      {!verifSuccess && (
        <div>
          <p>
            Sudah ada Akun? <a href="/login" style={{textDecoration:'underline', color:'#0185c6'}}> Login disini</a>
          </p>
        </div>
      )}
    </div>
  );
}

export default Daftar;
